<div>
  <p-treeTable [value]="optionsData" showGridlines>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [ngStyle]="{'width': col.width}" [ngClass]="col.styleClass">
          <button *ngIf="toExpand && col.label ==='T_OPTIONS_TITLE'" class="btn btn-default-white-background collapse-button pi pi-angle-right" (click)="toggleExpand()" ></button>
          <button *ngIf="!toExpand && col.label ==='T_OPTIONS_TITLE'" class="btn btn-default-white-background collapse-button pi pi-angle-down" (click)="toggleExpand()" ></button>
          <span>{{col.label | translate}}</span>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode  let-rowData="rowData" let-columns="columns">
      <tr [ttRow]="rowNode">
        @for (col of cols; let first = $first; let last = $last; track col) {
          <td [class]="{ 'td-value': rowNode.node.parent !== null}">
            @if (first) {

              <div class="flex items-center gap-2">
                <div class="option-name">
                  <p-treeTableToggler [rowNode]="rowNode"/>
                  <span class="option-name-title" translate>{{ rowData.name }}</span>
                  <div class="buttons-actions" *ngIf="showOptionActions(rowData)" >
                    <button class="btn action-button pi pi-pencil" (click)="onClickEditOptionButton(rowNode)">
                    </button>
                    <button class="btn action-button pi pi-copy" (click)="onClickCopyOptionButton(rowNode)">
                    </button>
                    <button class="btn action-button pi pi-trash" (click)="onClickDeleteOptionButton(rowNode)">
                    </button>
                  </div>
                </div>
                 <ng-container *ngIf="isExpanded(rowNode)">
                   <div class="description-option" translate>{{ rowData.description }}</div>
                   <div *ngIf="!rowNode.node.data.isValid && rowNode.node.data.mandatory "
                     class="warning-tooltip"
                     translate="T_MANDATORY_OPTION_MINIMUM_VALUES_WARNING">
                   </div>
                   <div *ngIf="rowNode.node.data.hasOptionValueWarning"
                     class="warning-tooltip"
                     translate="T_OPTION_VALUE_REQUIRED_WARNING">
                   </div>
              <div  class="option-flag-message">
                <div>
                  <span translate>T_ADMIN_OFFER_DATA_MANAGEMENT_OPTION_MANDATORY</span> : <b>{{ rowData.mandatory ? 'Yes' : 'No' }}</b>
                </div>
                <div *ngIf="showOnPopUpStatus">
                  <span translate>T_ADMIN_OFFER_DATA_MANAGEMENT_OPTION_ON_POP_UP</span> : <b>{{ rowData.onPopUp ? 'Yes' : 'No' }}</b>
                </div>
              </div>
                 </ng-container>
              </div>

            } @else if (last) {
              <div class="option-value">
                <span class="option-value-reference" translate>{{ rowData.reference }}</span>
                <div class="buttons-actions" *ngIf="showOptionValueActions(rowData)">
                  <button class="btn action-button pi pi-pencil" *ngIf="isEditable(rowData)" (click)="onClickEditOptionValueButton(rowData)"></button>
                  <button class="btn action-button pi pi-trash" (click)="onClickDeleteOptionValueButton(rowData)"></button>
                  <button class="btn action-button se-icon icon-big" (click)="onChangeOrderOptionValue('up', rowData)">arrow3_up</button>
                  <button class="btn action-button se-icon icon-big" (click)="onChangeOrderOptionValue('down', rowData)">arrow3_down</button>
                </div>
              </div>
            } @else {
              <span translate>{{ rowData.valueName }}</span>
              <div  class="description-option description-option-value" translate>{{ rowData.valueDescription }}</div>

            }
          </td>
        }
      </tr>

    </ng-template>
  </p-treeTable>

</div>
